import {Tabs, Tab, Box} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

import useEmmai from '../../../../../../hooks/providers/useEmmai';
import {formatMonth} from '../helpers';
import tabsStyles from '../tabsStyles';
import useMonthSelector from '../useMonthSelector/useMonthSelector';

const MonthSelectorContainer = muiStyled(Box)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing(0, 2)
}));

const MonthSelector = () => {
  const {emmaiRestitutionSelectedDate, proceedMonthChange} = useEmmai();
  const {visibleMonths, selectedIndex, handleSelect} = useMonthSelector(emmaiRestitutionSelectedDate, proceedMonthChange);

  return (
    <MonthSelectorContainer>
      <Tabs value={selectedIndex} onChange={(e, idx) => handleSelect(idx)} variant="scrollable" scrollButtons allowScrollButtonsMobile sx={tabsStyles}>
        {visibleMonths.map(date => (
          <Tab key={date.toISOString()} label={formatMonth(date)} sx={{px: 1.5}} />
        ))}
      </Tabs>
    </MonthSelectorContainer>
  );
};

export default MonthSelector;
